"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapWithReactStrictMode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const wrapWithReactStrictMode = (BaseComponent) => {
    const WrappedComponent = (props) => ((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, props)) }));
    return WrappedComponent;
};
exports.wrapWithReactStrictMode = wrapWithReactStrictMode;
//# sourceMappingURL=reactStrictModeWrapper.js.map